import { render, staticRenderFns } from "./form-switch.vue?vue&type=template&id=28dbf03a&scoped=true&"
import script from "./form-switch.vue?vue&type=script&lang=js&"
export * from "./form-switch.vue?vue&type=script&lang=js&"
import style0 from "./form-switch.vue?vue&type=style&index=0&id=28dbf03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbf03a",
  null
  
)

export default component.exports